import { Chip } from '@mui/material'
import { green, grey, orange, red } from '@mui/material/colors'
import { type FC } from 'react'

export type Verdict = 'yes' | 'partial' | 'no'

// Accepts the raw GraphQL string; falls back to Unjudged for anything unknown.
interface VerdictPillProps {
    verdict: string | null | undefined
}

const STYLES: Record<Verdict, { label: string; color: string; bg: string }> = {
    yes: { label: 'Yes', color: green[900], bg: green[50] },
    partial: { label: 'Partial', color: orange[900], bg: orange[50] },
    no: { label: 'No', color: red[900], bg: red[50] },
}

const UNJUDGED = { label: 'Unjudged', color: grey[700], bg: grey[100] }

export const VerdictPill: FC<VerdictPillProps> = ({ verdict }) => {
    const style =
        (verdict != null && verdict in STYLES
            ? STYLES[verdict as Verdict]
            : null) ?? UNJUDGED
    return (
        <Chip
            label={style.label}
            size="small"
            sx={{
                bgcolor: style.bg,
                color: style.color,
                fontWeight: 500,
                fontSize: '0.7rem',
                height: 20,
            }}
        />
    )
}
